'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * OtherMethods component
 * @param {OtherMethodsPropsType} param0 The field props
 * @returns {React.Element<*>} React element
 */
var OtherMethods = function OtherMethods(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'qd__other-methods' },
    _react2.default.createElement(
      _buttons.Anchor,
      { outfit: 'primary small', onClick: onClick },
      text
    )
  );
};

exports.default = OtherMethods;